import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { speed } from 'Lib/speed/speed';
import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import { onBpChange } from 'Lib/on-bp-change/on-bp-change';

const $slider = $('.journal-items_slider .journal-items__box');
const sPic = '.journal-items__img';
const cOwl = 'owl-carousel';

function setSliderJournalItems() {
    if (getW() > eksmoBP.smMax) {
        $slider.trigger('destroy.owl.carousel')
            .removeClass(cOwl)
            .addClass(cOwl)
            .owlCarousel({
                smartSpeed: speed / 2,
                autoWidth: true,
                nav: true,
                dots: false,
                navClass: ['journal-items__slider-arrow-prev arrow arrow_prev', 'journal-items__slider-arrow-next arrow arrow_next'],
                navText: ['', ''],
                responsive: {
                    991: { items: 3, margin: 30, slideBy: 3, autoWidth: false, nav: true },
                    1500: { items: 4, margin: 40, slideBy: 4, autoWidth: false, nav: true },
                },
                onInitialized(e) {
                    onScreen($(e.target).find(sPic), loadSrcOrBg);
                },
            });
    }
}

onBpChange(eksmoBP.smMax, (isLess) => {
    if (isLess) {
        $slider.trigger('destroy.owl.carousel').removeClass(cOwl);
    } else {
        setSliderJournalItems();
    }
});

setSliderJournalItems();